var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mybluelink",attrs:{"href":`mailto:support@mydadomain.com?subject=EM Question: ${_vm.subject}`}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }